<template>
  <PdpErrorBoundary>
    <ErrorOwners :owners="['bot-squad-search-and-recommendation-front']">
      <DealSticker
        v-if="productResponse?.hasDeals"
        class="my-8 w-full sm:mb-16 md:mt-0 md:!w-auto"
        :icon
      />
    </ErrorOwners>
  </PdpErrorBoundary>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import ErrorOwners from '@backmarket/nuxt-module-logger/components/ErrorOwners.vue'

import DealSticker from '~/scopes/product-core/components/presentationals/DealSticker/DealSticker.vue'
import PdpErrorBoundary from '~/scopes/product-core/components/presentationals/PdpErrorBoundary/PdpErrorBoundary.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

defineProps<{
  icon?: Component
}>()

const { data: productResponse } = useFetchProduct()
</script>
